import { Form } from "@/helpers/Form";
import Pager from "@/helpers/Pager";
import { FilterModel } from "../services/ReservationsService";

export default {
    namespaced: true,
    state: {
        filter: Form.createPersistedState<FilterModel>({
            today: false,
            tomorrow: false,
            arrival: false,
            departure: false,
            custom: null,
            bookingTypes: [],
            localizator: null,
            citiesIds: [],
            districtsIds: [],
            propertiesIds: [],
            webSource: null
        }, undefined, 'renterReservationsFilter'),
        pager: new Pager(1, undefined, 'ClientName', 'ASC')
    }
};
